import { z } from 'zod';

// 1. Define schema for your environment variables
const envSchema = z.object({
  // Public variables (exposed to client)
  VITE_PUBLIC_DOMAIN: z.string().min(1, 'VITE_PUBLIC_DOMAIN is required'),
  VITE_PUBLIC_APP_ENV: z.enum([
    'localhost',
    'development',
    'test',
    'production',
  ]),
  VITE_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string().min(0),
  // Optional axios base URL for API client
  VITE_API_BASE_URL: z.string().optional(),
  // Auth0 configuration
  VITE_PUBLIC_AUTH0_DOMAIN: z
    .string()
    .min(1, 'VITE_PUBLIC_AUTH0_DOMAIN is required'),
  VITE_PUBLIC_AUTH0_CLIENT_ID: z
    .string()
    .min(1, 'VITE_PUBLIC_AUTH0_CLIENT_ID is required'),
  VITE_PUBLIC_AUTH0_REDIRECT_URI: z.string().optional(),
});

// 2. Gather variables from import.meta.env (Vite's env object)
const rawEnv = {
  VITE_PUBLIC_DOMAIN: import.meta.env.VITE_PUBLIC_DOMAIN,
  VITE_PUBLIC_APP_ENV: import.meta.env.VITE_PUBLIC_APP_ENV,
  VITE_PUBLIC_STRIPE_PUBLISHABLE_KEY: import.meta.env
    .VITE_PUBLIC_STRIPE_PUBLISHABLE_KEY,
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  // Auth0 configuration
  VITE_PUBLIC_AUTH0_DOMAIN: import.meta.env.VITE_PUBLIC_AUTH0_DOMAIN,
  VITE_PUBLIC_AUTH0_CLIENT_ID: import.meta.env.VITE_PUBLIC_AUTH0_CLIENT_ID,
  VITE_PUBLIC_AUTH0_REDIRECT_URI: import.meta.env
    .VITE_PUBLIC_AUTH0_REDIRECT_URI,
};

// 3. Validate and throw if invalid
const parsed = envSchema.safeParse(rawEnv);

if (!parsed.success) {
  // Print all validation errors and stop the app
  console.error('❌ Invalid environment variables:', z.treeifyError(parsed.error));
  throw new Error('Invalid environment variables');
}

// 4. Export the validated, typed env object
export const env = parsed.data;
